import styled from "styled-components"
import { device } from "breakpoints"

export const ImgTextCustomContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 40px 0;
  background: teal;

  @media ${device.tablet} {
    flex-direction: row;
    width: 100%;
    align-items: center;
  }

  :hover {
    h3 {
      color: ${(props) => props.theme.primaryColor};
    }
  }
`
export const ImgWrapper = styled.div`
  position: relative;
  @media ${device.tablet} {
    flex-direction: row;
    width: 50%;
  }
`

export const TextWrapper = styled.div`
  padding: 30px;
  @media ${device.tablet} {
    width: 50%;
    padding: 50px;
  }

  h3 {
    font-size: 28px;
    margin-bottom: 20px;
    width: 100%;

    @media ${device.desktop} {
      font-size: 36px;
    }

    a {
      color: inherit;
      width: 100%;

      :before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
      }
    }
  }

  p {
    width: 100%;
    font-size: 16px;
    margin-bottom: 30px;
    color: black;
  }

  > *:last-child {
    margin-bottom: 0;
  }
`
